import React, { Component } from 'react'
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import clusterIcon1 from "./cluster_icons/m1.png"
import clusterIcon2 from "./cluster_icons/m2.png"
import clusterIcon3 from "./cluster_icons/m3.png"
import clusterIcon4 from "./cluster_icons/m4.png"
import clusterIcon5 from "./cluster_icons/m5.png"

const chooseMarkerIcon = (count) => {
  if (count < 100) {
    return clusterIcon1
  } else if (count < 1000) {
    return clusterIcon2
  } else if (count < 10000) {
    return clusterIcon3
  } else if (count < 100000) {
    return clusterIcon4
  } else {
    return clusterIcon5
  }
}

const MapWithAMarkerClusterer = withScriptjs(withGoogleMap(
  props => {
    const markers = props.markers || []
    return (
      <GoogleMap defaultZoom={5} defaultCenter={{ lat: 55.0172661, lng: -3.5569401 }} onBoundsChanged={props.onBoundsChanged} ref={props.onMapMounted}>
        {markers.map(marker => {
          let wreckClickHandler = function(event) {
            props.onMarkerClick(this.map, event, marker)
          }
          let clusterClickHandler = function(event) {
            props.onClusterClick(this.map, event, marker)
          }

          if (!marker.count) {
            return (<Marker key={marker.uuid} position={{ lat: marker.latitude, lng: marker.longitude }} onClick={wreckClickHandler} data={marker} />)
          } else {
            return (<Marker icon={{ url: chooseMarkerIcon(marker.count) }} label={"" + marker.count} key={marker.uuid} position={{ lat: marker.latitude, lng: marker.longitude }} onClick={clusterClickHandler} />)
          }
        })}
      </GoogleMap>
    )
  }
))

class GoogleMapOfWrecks extends Component {
  mapUpdater = null
  mapComponent = null
  zoom = null
  state = { markers: [] }

  markerClickHandler = (googleMap, clickEvent, wreck) => {
    googleMap.setCenter(clickEvent.latLng)
    if (googleMap.getZoom() < 11) { googleMap.setZoom(11) }
    this.props.showWreckDetailHandler(wreck)
  }

  clusterClickHandler(googleMap, clickEvent, wreck) {
    googleMap.setCenter(clickEvent.latLng)
    googleMap.setZoom(googleMap.getZoom() + 1)
  }

  boundsChangedHandler = () => {
    clearTimeout(this.mapUpdater)
    this.mapUpdater = setTimeout(() => { this.boundsHaveChanged() }, 250)
  }

  boundsHaveChanged() {
    this.bounds = this.mapComponent.getBounds()
    this.zoom = this.mapComponent.getZoom()
    this.recalculateState()
  }

  mapMountedHandler = (ref) => {
    if (ref) {
      this.mapComponent = ref
      this.bounds = ref.getBounds()
      this.zoom = ref.getZoom()
      this.recalculateState()
    }
  }

  recalculateState() {
    if (this.props.wrecks.length > 0 && this.bounds && this.zoom) {
      const bounds = this.bounds
      const zoom   = this.zoom
      const wrecks = this.props.wrecks

      let result
      if (zoom > 8) {
        result = this.allMarkersInBounds(wrecks, bounds)
      } else {
        result = this.clustersOfWrecks(wrecks, zoom)
        result = this.allMarkersInBounds(result, bounds)
      }

      this.setState(() => ({
        markers: result
      }))
    }
  }

  allMarkersInBounds(wrecks, bounds) {
    const result = []
    let wreckLatLng
    wrecks.forEach((wreck) => {
      wreckLatLng = { lat: wreck.latitude, lng: wreck.longitude }

      if (bounds.contains(wreckLatLng)) {
        result.push(wreck)
      }
    })
    return result
  }

  roundAmountFromZoom(zoom) {
    if (zoom <= 2) {
      return 0.1
    } else if (zoom === 3) {
      return 0.2
    } else if (zoom === 4) {
      return 0.4
    } else if (zoom === 5) {
      return 0.5
    } else if (zoom === 6) {
      return 1
    } else if (zoom === 7) {
      return 2
    } else {
      return 4
    }
  }

  clustersOfWrecks(wrecks, zoom) {
    const roundAmount = this.roundAmountFromZoom(zoom)
    let result = {}
    let roundedLat, roundedLng, cluster, clusterUuid, currentCount
    wrecks.forEach((wreck) => {
      roundedLat = Math.round(wreck.latitude * roundAmount) / roundAmount
      roundedLng = Math.round(wreck.longitude * roundAmount) / roundAmount
      clusterUuid = "" + roundedLat + "-" + roundedLng
      cluster = result[clusterUuid]
      if (cluster) {
        currentCount = cluster.count || 1
        cluster = {
          uuid: clusterUuid,
          latitude: ((cluster.latitude  * currentCount) + wreck.latitude ) / (currentCount + 1),
          longitude: ((cluster.longitude * currentCount) + wreck.longitude) / (currentCount + 1),
          count: currentCount + 1
        }
      } else {
        cluster = wreck
      }

      result[clusterUuid] = cluster
    })
    return Object.values(result)
  }

  render() {
    const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY
    return (
      <MapWithAMarkerClusterer
        googleMapURL={"https://maps.googleapis.com/maps/api/js?key=" + apiKey + "&v=3.exp&libraries=geometry,drawing,places"}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `520px` }} />}
        mapElement={<div style={{ height: `100%` }} />}
        markers={this.state.markers}
        onMarkerClick={this.markerClickHandler}
        onClusterClick={this.clusterClickHandler}
        onBoundsChanged={this.boundsChangedHandler}
        onMapMounted={this.mapMountedHandler}
      />
    )
  }
}

export default GoogleMapOfWrecks;



// WEBPACK FOOTER //
// ./src/components/google_map_of_wrecks.js